/*
 * Přidání doplňku z kompaktního cross-sellu.
 * Jen jednovariantní produkty — u vícevariantních je v šabloně odkaz
 * na detail, aby se nepřidala špatná velikost.
 */
(function () {
  'use strict';
  if (window._ilicoXsell) return;
  window._ilicoXsell = true;

  function pridej(btn) {
    var id = btn.getAttribute('data-xsell-add');
    if (!id || btn.disabled) return;

    var puvodni = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        btn.textContent = '✓';
        btn.classList.add('is-done');
        /* Sdílený modul přepíše počet i cenu v hlavičce a překreslí košík. */
        return window.ilicoKosik ? window.ilicoKosik.obnov() : null;
      })
      .catch(function () {
        btn.textContent = puvodni;
        btn.disabled = false;
      })
      .finally(function () {
        setTimeout(function () {
          btn.textContent = puvodni;
          btn.disabled = false;
          btn.classList.remove('is-done');
        }, 1500);
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-xsell-add]');
    if (btn) {
      e.preventDefault();
      pridej(btn);
    }
  });
})();
